import { render, staticRenderFns } from "./ward-select.vue?vue&type=template&id=33743290&scoped=true"
import script from "./ward-select.vue?vue&type=script&lang=js"
export * from "./ward-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33743290",
  null
  
)

/* custom blocks */
import block0 from "@/locale/ward-localization.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CUsers%5Cnikod%5CDocuments%5Cgithub%5Cnikodz%5CWebmed.Core.VueJS%5Csrc%5Ccomponent%5Cward-select.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports